export default class extends Controller {
  static targets = ['select', 'description'];

  connect() {
    App.DynamicSelect.onChange(this.selectTarget, this.getAudienceDescription.bind(this));
  }

  getAudienceDescription() {
    const url = this.baseURL.replace('SEGMENT_ID', this.selectTarget.value);
    App.Helpers.ajaxRequest({
      url,
      method:         'GET',
      successHandler: this.setDescriptionContent.bind(this)
    });
  }

  setDescriptionContent({ segment }) {
    this.descriptionTarget.innerHTML = (segment && segment.description) || '(None)';
  }

  //
  // INTERNAL USE
  //

  get baseURL() {
    return this.data.get('base-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/audience-row-controller.js